import { Cell, CellWithHierarchy } from '@pelckmans/elementis/components/table';
import { ComponentProps, useContext } from 'react';
import HorizontalScrollContext from '../../../../../shared-components/table/context/HorizontalScrollContext';
import { isQuantifiable } from '../../../../../utils/results';
import { TableDataRow } from '../types';
import ResultsCell from './cells/ResultsCell';

export const TableRow = ({ row, detailView }: { row: TableDataRow; detailView: boolean }) => {
  const { horizontalScroll } = useContext(HorizontalScrollContext);

  const subTitle =
    row.subTitleBot || row.subTitleTop
      ? {
          text: row.subTitleBot || row.subTitleTop || '',
          position: row.subTitleBot ? ('bottom' as const) : ('top' as const),
        }
      : undefined;

  const cell = row.href ? (
    <Cell.Link title={row.title} startAdornment={row.icon} subTitle={subTitle} linkProps={{ to: row.href }} />
  ) : (
    <Cell.Text title={row.title} startAdornment={row.icon} subTitle={subTitle} />
  );

  return (
    <tr data-testid={row.id} key={row.id}>
      <CellWithHierarchy
        hierarchyProps={{
          level: row.level as ComponentProps<typeof CellWithHierarchy>['hierarchyProps']['level'],
          hasCollapsibleParent: true,
        }}
        sticky={!detailView && horizontalScroll}
        className="scorable-item-column"
        minWidth="xl"
        maxWidth="xl"
        scope="row"
      >
        {cell}
      </CellWithHierarchy>
      {row.columns.map((column, i) => {
        if (!column) {
          return <Cell key={i} />;
        }

        if ('Cell' in column) {
          const CustomCell = column.Cell;
          return <CustomCell key={column.id} />;
        }

        return (
          <Cell key={`${column.exerciseId}-${column.isAssignment}-${column.memberId}`} minWidth="xs" maxWidth="xs">
            <span className="results-cell">
              <ResultsCell
                quantifiable={isQuantifiable({
                  score: column.score,
                  unachievable: column.unachievable,
                  status: column.status,
                })}
                needsGrading={Boolean(column.needsGrading)}
                status={column.status}
                score={column.score}
                isLastPhase={column.isLastPhase}
                phases={column.phases}
              />
            </span>
          </Cell>
        );
      })}
    </tr>
  );
};
